/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { HistoryRequestBuilderRequestsMetadata, type HistoryRequestBuilder } from './history/index.js';
// @ts-ignore
import { ProjectionRequestBuilderRequestsMetadata, type ProjectionRequestBuilder } from './projection/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /contracts/{contract-id}/consumption
 */
export interface ConsumptionRequestBuilder extends BaseRequestBuilder<ConsumptionRequestBuilder> {
    /**
     * The history property
     */
    get history(): HistoryRequestBuilder;
    /**
     * The projection property
     */
    get projection(): ProjectionRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const ConsumptionRequestBuilderUriTemplate = "{+baseurl}/contracts/{contract%2Did}/consumption";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ConsumptionRequestBuilderNavigationMetadata: Record<Exclude<keyof ConsumptionRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    history: {
        requestsMetadata: HistoryRequestBuilderRequestsMetadata,
    },
    projection: {
        requestsMetadata: ProjectionRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
